import { render, staticRenderFns } from "./cool.modal.vue?vue&type=template&id=2ca6e22e&scoped=true"
import script from "./cool.modal.vue?vue&type=script&lang=js"
export * from "./cool.modal.vue?vue&type=script&lang=js"
import style0 from "./cool.modal.vue?vue&type=style&index=0&id=2ca6e22e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6e22e",
  null
  
)

export default component.exports